var vl = {};

vl.isEmail = function(s) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(s);
};

export default vl;
